<script setup>
defineProps({
  level: { type: String, default: 'h1' }, /* h1 | h2 | h3 */
  tone: { type: String, default: 'ink' }  /* ink | gold | copper */
})
</script>

<template>
  <component :is="level" class="headline" :class="[`headline--${level}`, `headline--${tone}`]">
    <slot />
  </component>
</template>

<style scoped>
.headline {
  font-family: var(--font-display);
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: var(--lh-tight);
  margin: 0;
  text-transform: uppercase;
}
.headline--h1 {
  font-size: clamp(var(--fs-44), 8.5vw, var(--fs-120));
  letter-spacing: 0.01em;
}
.headline--h2 { font-size: clamp(var(--fs-32), 5vw, var(--fs-60)); }
.headline--h3 { font-size: clamp(var(--fs-21), 2.6vw, var(--fs-32)); }

.headline--ink    { color: var(--ink); }
.headline--gold   { color: var(--gold); }
.headline--copper { color: var(--copper); }

/* Optical-emphasis: <em> children render in gold */
.headline :deep(em) {
  font-style: normal;
  color: var(--gold);
}
</style>
